// import React from "react";
// import sampleVideo from "./Cloudimages/01_SNOWLAND_30SEC FINAL OUTPUT.mp4";

// const FoodBanner2 = () => {
//   return (
//     <>
//       <style>{`
//         .food-banner2 {
//           display: flex;
//           flex-direction: column;ss
//           align-items: center;
//           background: #4e1f5cff;
//           border-radius: 10px;
//           color: #fff;
//           padding: 40px 5%;
//         }

//         /* Top Heading */
//         .top-section2 {
//           text-align: center;
//           margin-bottom: 50px;
//           max-width: 800px;
//         }

//         .top-section2 h2 {
//           font-size: 2.8rem;
//           margin-bottom: 15px;
//           font-weight: bold;
//         }

//         .top-section2 p {
//           font-size: 1.1rem;
//           line-height: 1.6;
//           color: #f0f0f0;
//         }

//         /* Banner Content */
//         .banner-content2 {
//           display: flex;
//           align-items: flex-start;
//           justify-content: space-between;
//           flex-wrap: wrap;
//           width: 100%;
//           gap: 30px;
//         }

//         /* Left Section */
//         .banner-left2 {
//           flex: 1 1 300px;
//           max-width: 600px;
//         }

//         .banner-left2 h1 {
//           font-size: 2.8rem;
//           font-weight: bold;
//           line-height: 1.3;
//           margin-bottom: 20px;
//         }

//         .banner-left2 p {
//           font-size: 1rem;
//           line-height: 1.6;
//           margin-bottom: 25px;
//         }

//         /* Right Section (Video) */
//         .banner-right2 {
//           flex: 1 1 300px;
//           max-width: 600px;
//           text-align: center;
//         }

//         .video-box2 {
//           width: 100%;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 6px 20px rgba(0,0,0,0.3);
//         }

//         .video-box2 video {
//           width: 100%;
//           height: auto;
//           display: block;
//         }

//         /* Responsive */
//         @media (max-width: 1024px) {
//           .top-section2 h2 {
//             font-size: 2.2rem;
//           }
//           .banner-left2 h1 {
//             font-size: 2.2rem;
//           }
//         }

//         @media (max-width: 768px) {
//           .banner-content2 {
//             flex-direction: column;
//             align-items: center;
//           }

//           .banner-left2,
//           .banner-right2 {
//             max-width: 100%;
//           }

//           .banner-left2 h1 {
//             font-size: 2rem;
//           }

//           .banner-left2 p {
//             font-size: 0.95rem;
//           }
//         }

//         @media (max-width: 480px) {
//           .food-banner2 {
//             padding: 30px 3%;
//           }

//           .banner-left2 h1 {
//             font-size: 1.6rem;
//           }

//           .banner-left2 p {
//             font-size: 0.9rem;
//           }

//           .video-box2 {
//             width: 100%;
//           }
//         }
//       `}</style>

//       <div className="food-banner2">
//         {/* Optional Top Section */}
//         <div className="top-section2">
//           <h2>Delicious Food Awaits</h2>
//           <p>Enjoy fresh, healthy meals prepared just for you, anytime, anywhere.</p>
//         </div>

//         {/* Banner Content */}
//         <div className="banner-content2">
//           {/* Left Section */}
//           <div className="banner-left2">
//             <h1>
//               Food that makes <br /> you happy
//             </h1>
//             <p>
//               While eating at a restaurant is an enjoyable occasional treat, most individuals and families prepare meals at home.
//             </p>
//           </div>

//           {/* Right Section (Video) */}
//           <div className="banner-right2">
//             <div className="video-box2">
//               <video src={sampleVideo} autoPlay muted loop playsInline />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default FoodBanner2;








import React, { useEffect, useState } from "react";
import axios from "axios";
import Homebackground from"../../../images/homebackground.jpg";

const FoodBanner2 = () => {
  const [title, setTitle] = useState("Food that makes you happy");
  const [desc, setDesc] = useState(
    "While eating at a restaurant is an enjoyable occasional treat, most individuals and families prepare meals at home."
  );
  const [media, setMedia] = useState("");

  useEffect(() => {
    const fetchAdvertisement = async () => {
      try {
        const token = localStorage.getItem("authToken");

        const response = await axios.get(
          "https://backend.maamaas.com/food/superadmin/advertisement/all",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            }
          }
        );

        const data = response.data;

        if (!Array.isArray(data) || data.length === 0) {
          console.warn("No advertisement found");
          return;
        }

        const item = data[0]; // First item only

        setTitle(item.title || title);
        setDesc(item.description || desc);
        setMedia(item.mediaFile || "");

      } catch (error) {
        console.error("GET Advertisement Error:", error);
      }
    };

    fetchAdvertisement();
  }, []);

  const isVideo = media.endsWith(".mp4");

  return (
    <>
      <style>{`
        .food-banner2 {
          display: flex;
          flex-direction: column;ss
          align-items: center;
          background: #4e1f5cff;
          border-radius: 10px;
          color: #fff;
          padding: 40px 5%;
        }

        /* Top Heading */
        .top-section2 {
          text-align: center;
          margin-bottom: 50px;
          max-width: 800px;
        }

        .top-section2 h2 {
          font-size: 2.8rem;
          margin-bottom: 15px;
          font-weight: bold;
        }

        .top-section2 p {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #f0f0f0;
        }

        /* Banner Content */
        .banner-content2 {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          flex-wrap: wrap;
          width: 100%;
          gap: 30px;
        }

        /* Left Section */
        .banner-left2 {
          flex: 1 1 300px;
          max-width: 600px;
        }

        .banner-left2 h1 {
          font-size: 2.8rem;
          font-weight: bold;
          line-height: 1.3;
          margin-bottom: 20px;
        }

        .banner-left2 p {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 25px;
        }

        /* Right Section (Video) */
        .banner-right2 {
          flex: 1 1 300px;
          max-width: 600px;
          text-align: center;
        }

        .video-box2 {
          width: 100%;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 6px 20px rgba(0,0,0,0.3);
        }

        .video-box2 video {
          width: 100%;
          height: auto;
          display: block;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .top-section2 h2 {
            font-size: 2.2rem;
          }
          .banner-left2 h1 {
            font-size: 2.2rem;
          }
        }

        @media (max-width: 768px) {
          .banner-content2 {
            flex-direction: column;
            align-items: center;
          }

          .banner-left2,
          .banner-right2 {
            max-width: 100%;
          }

          .banner-left2 h1 {
            font-size: 2rem;
          }

          .banner-left2 p {
            font-size: 0.95rem;
          }
        }

        @media (max-width: 480px) {
          .food-banner2 {
            padding: 30px 3%;
          }

          .banner-left2 h1 {
            font-size: 1.6rem;
          }

          .banner-left2 p {
            font-size: 0.9rem;
          }

          .video-box2 {
            width: 100%;
          }
        }
      `}</style>

      <div className="food-banner2">
        <div className="banner-content2" style={{ width: "100%", display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>

          <div className="banner-left2" style={{ flex: "1 1 300px", maxWidth: "600px" }}>
            <h1>{title}</h1>
            <p>{desc}</p>
          </div>

          <div className="banner-right2" style={{ flex: "1 1 300px", maxWidth: "600px" }}>
            <div className="video-box2">
              {isVideo ? (
                <video src={media} autoPlay muted loop playsInline style={{ width: "100%", borderRadius: "10px" }} />
              ) : (
                <img src={Homebackground} alt="banner-media" style={{ width: "100%", borderRadius: "10px" }} />
              )}
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default FoodBanner2;
